import React from "react";
// import loadingSpinner from "../component/loading.gif"

function LoadingComponent({ label = "LOADING..." }) {
  return (
    <div>
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      <div className="fixed z-0 inset-0 overflow-y-auto">
        <div className="relative mx-auto my-auto mt-60 w-40 h-44 bg-white rounded-md">
          <div className="mx-auto">
            {/* <img className="mx-auto w-32 h-32" src={loadingSpinner} alt="pic" /> */}
            <h2 className="p-2 font-bold text-[#ff0000] text-lg text-center">
              {label}
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoadingComponent;